import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contribution-table',
  templateUrl: './contribution-table.component.html',
  styleUrls: ['./contribution-table.component.css']
})
export class ContributionTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
